import { configureStore } from "@reduxjs/toolkit";
import rolesReducer from "./slices/rolesListSlice";
import applicationsReducer from "./slices/applicationsSlice";
import utilsReducer from "./slices/utilsSlice";

const store = configureStore({
  reducer : {
      roles: rolesReducer,
      applications: applicationsReducer,
      utils: utilsReducer
  }
})

export default store;
